<template>
  <div class="faq">
    <div class="faq-question-e" v-b-toggle.q76>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q76.</b></b-col>
        <b-col cols="11">{{ $t("q76") }}</b-col>
      </b-row>
      <b-collapse id="q76">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A76.</b></b-col>
          <b-col>
            <div>
              {{ $t("a76-1") }} : <span class="bd-url" @click="goInfoEdriveLoginUrl">{{edriveLoginUrl}} </span>
            </div>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>

import { EshApi } from '@/api';

export default {

  data() {
    return {
      edriveLoginUrl: ""
    };
  },
  async created() {
    const {data:edriveLoginUrl} = await EshApi.getEdriveUrl();
    this.edriveLoginUrl = edriveLoginUrl;

  },
  methods: {
    goInfoEdriveLoginUrl(){
      window.location.href = this.edriveLoginUrl
    }
  }
};
</script>


<i18n src="@/public/locales/modules/faq/components/FaqEDrive.json" />